
/**
 * Module dependencies.
 */

import { BaseProductsList } from 'client/containers/products/products-list';
import { Helmet } from 'react-helmet';
import { Payspace } from 'slyk-web-libs/types';
import { ProductDetails } from 'client/containers/products/product-details';
import { Redirect, Route, Switch } from 'react-router-dom';
import { usePayspace } from 'slyk-web-libs/payspace-context';
import { useTranslate } from 'slyk-web-libs/i18n';
import React from 'react';
import routes from 'slyk-web-libs/config/payspace-routes';

/**
 * Export `Products` container.
 */

export function Products(): JSX.Element {
  const { translate } = useTranslate();
  const { name } = usePayspace() as Payspace;

  return (
    <>
      <Helmet titleTemplate={'%s'}>
        <title>
          {translate('title', { name })}
        </title>
      </Helmet>

      <Switch>
        <Route
          exact
          path={routes.products.base}
        >
          <BaseProductsList />
        </Route>

        <Route
          exact
          path={routes.products.details}
        >
          <ProductDetails />
        </Route>

        <Redirect to={routes.products.base} />
      </Switch>
    </>
  );
}
